// extracted by mini-css-extract-plugin
export var brand = "_ao-9";
export var compact = "_ao-6";
export var extraSmall = "_ao-7";
export var icon = "_ao-0";
export var large = "_ao-4";
export var light = "_ao-1";
export var medium = "_ao-5";
export var outline = "_ao-b";
export var primaryDark = "_ao-a";
export var primaryLight = "_ao-8";
export var primaryModern = "_ao-c";
export var success = "_ao-2";
export var successSolid = "_ao-3";